import React, { useState } from "react";
import { db } from "../firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from 'sweetalert2';

const CreateUser = () => {
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [dirreccion, setDirreccion] = useState("");
  const [userName, setUserName] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nombre || !email || !telefono || !contrasena || !dirreccion || !userName) {
      Swal.fire({
        title: "Error",
        text: "Por favor, completa todos los campos.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }
    db.collection("Usuarios")
      .add({
        nombre: nombre,
        email: email,
        telefono: telefono,
        contraseña: contrasena,
        dirreccion: dirreccion,
        usuario:userName
        // Agrega más campos según los datos que quieras recopilar
      })
      .then(() => {
        console.log("Datos enviados correctamente");
        Swal.fire({
          title: 'Registro con Exito!',
          text: `Muchas Gracias: ${nombre}.`,
          icon: 'success',
          confirmButtonText: 'Aceptar',footer:"<p>Por favor ingrese su nombre de usuario sin comas, espacios o caracteres especiales, de lo contrario no podrá acceder a su cuenta.</p>"
          
        });
        setNombre("");
      setEmail("");
      setTelefono("");
      setContrasena("");
      setDirreccion("");
      setUserName("");
      })
      
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: "Hubo un problema al enviar los datos. Por favor, intenta de nuevo más tarde.",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        console.error("Error al enviar los datos: ", error);
      });
  };

  return (
    <div className="container w-75 mb-5">
          <img src="img/logoMartin.png" alt="" className='w-25' />
        <h1>Registraste</h1>
      <form onSubmit={handleSubmit} className="needs-validation" noValidate>
        <div className="mb-3">
          <label htmlFor="nombre" className="form-label">
          <i class="fa-solid fa-user"></i> Nombre:
          </label>
          <input
            type="text"
            className="form-control"
            id="nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />
          <div className="invalid-feedback">Ingresa tu nombre completo.</div>
        </div>
        <div className="mb-3">
          <label htmlFor="nombre" className="form-label">
          <i class="fa-sharp fa-solid fa-user"></i> Usuario:
          </label>
          <input
            type="text"
            className="form-control"
            id="nombre"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            required
          />
          <div className="invalid-feedback">Ingresa un nombre de usuario correcto.</div>
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label">
          <i class="fa-sharp fa-solid fa-envelope"></i> Email:
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            
          />
          <div className="invalid-feedback">Ingresa un correo electrónico válido.</div>
        </div>

        <div className="mb-3">
          <label htmlFor="telefono" className="form-label">
          <i class="fa-solid fa-phone"></i>  Teléfono:
          </label>
          <input
            type="tel"
            className="form-control"
            id="telefono"
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
            required
          />
          <div className="invalid-feedback">Ingresa un número telefónico válido.</div>
        </div>

        <div className="mb-3">
          <label htmlFor="contrasena" className="form-label">
          <i class="fa-solid fa-lock"></i> Contraseña:
          </label>
          <input
            type="password"
            className="form-control"
            id="contrasena"
            value={contrasena}
            onChange={(e) => setContrasena(e.target.value)}
            required
          />
          <div className="invalid-feedback">Ingresa una contraseña segura.</div>
        </div>
        <div className="mb-3">
          <label htmlFor="dirrrecion" className="form-label">
          <i class="fa-sharp fa-solid fa-location-dot"></i> Dirrecion:
          </label>
          <input
            type="text"
            className="form-control"
            id="dirrrecion"
            value={dirreccion}
            onChange={(e) => setDirreccion(e.target.value)}
          
          />
          
          <div className="invalid-feedback">Ingresa una dirreccion correcta.</div>
        </div>
        <div className="text-center">
          <div className="container w-75 text-start">

          <p>Tus datos personales se utilizarán para procesar tu pedido, mejorar tu experiencia en esta web, gestionar el acceso a tu cuenta y otros propósitos descritos en nuestra política de privacidad.</p>

          </div>
          <button type="submit" className="btn btn-warning">
            Registrarse
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateUser;
